import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Nunca entendí por qué mi hijo era tan intenso emocionalmente. Con el Tomo 3 entendí todo en una tarde. Lloré de alivio. Por fin tenía palabras para lo que veía en él.',
    author: 'Mariana G.',
    details: 'Mamá de Tomás, 6 años · Buenos Aires',
    photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Pensé que era un producto más de crianza. Resultó ser lo más útil y concreto que leí en 4 años de ser mamá. Lo recomiendo sin dudarlo.',
    author: 'Carolina V.',
    details: 'Mamá de Sofía y Lucía · Bogotá',
    photo: 'https://images.unsplash.com/photo-1543342384-1f1350e27861?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'El Diccionario de Conductas me salvó la semana. Lo tengo guardado en el teléfono y lo abro cada vez que no sé qué hacer. Es como tener una guía de respuestas al instante.',
    author: 'Valentina R.',
    details: 'Mamá de Mateo, 4 años · Ciudad de México',
    photo: 'https://images.unsplash.com/photo-1581952976147-5a2d15560349?w=200&h=200&fit=crop&crop=face'
  }];
  return <section className="py-8 md:py-10 px-4 bg-cream-100 relative" data-id="element-245">
      {/* Subtle pink tint overlay */}
      <div className="absolute inset-0 bg-dusty-rose-50/50 mix-blend-multiply" data-id="element-246"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-247">
        <FadeIn data-id="element-248">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-burgundy-900 mb-6 md:mb-10" data-id="element-249">
            Lo que dicen las mamás que ya tienen su colección
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-250">
          {testimonials.map((testimonial, idx) => <FadeIn key={idx} delay={idx * 0.15} direction="up" data-id="element-251">
              <div className="bg-white rounded-2xl p-5 md:p-8 shadow-md border border-cream-200 h-full flex flex-col relative" data-id="element-252">
                <Quote className="absolute top-4 md:top-6 right-4 md:right-6 w-8 h-8 md:w-10 md:h-10 text-dusty-rose-200 opacity-50" data-id="element-253" />

                {/* Real photo avatar */}
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full mb-4 md:mb-6 overflow-hidden border-2 border-dusty-rose-200 shadow-sm flex-shrink-0" data-id="element-254">
                  <img src={testimonial.photo} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-255" />
                </div>

                <p className="font-heading italic text-base md:text-lg text-burgundy-800 mb-5 md:mb-8 flex-grow leading-relaxed" data-id="element-256">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto pt-4 md:pt-6 border-t border-cream-100" data-id="element-257">
                  <p className="font-bold text-burgundy-900 text-sm md:text-base" data-id="element-258">
                    {testimonial.author}
                  </p>
                  <p className="text-xs md:text-sm text-burgundy-600 mt-1" data-id="element-259">
                    {testimonial.details}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}